import { Component } from '@angular/core';

@Component({
  selector: 'buttons-wrapper',
  templateUrl: './buttons-wrapper.component.html',
  styleUrls: ['./buttons-wrapper.component.scss']
})
export class ButtonsWrapperComponent {

}
